@if (showError) {
  <div class="screensize-monitor-container d-flex vh-100 w-100 justify-content-center">
    <div class="screensize-monitor align-self-center text-center">
      <img src="assets/park-evaluations-logo.svg" title="Park Evaluations" width="160" />
      <h2 class="mt-5">Oops, screensize not supported!</h2>
      <p>You must be on at least a 900px screen.</p>
    </div>
  </div>
}
